import { getModel } from "core-web/state";
import DataLayer from "./DataLayer";

export default ({ query, products, list, algoliaIndexType }) => {
    const application = getModel("application");

    const impressions = DataLayer.getImpressions(
        products.slice(0, 12).map((item) => {
            if (list) {
                item.list = list;
            }
            return item;
        }),
    );

    const objectIds = products
        .slice(0, 20)
        .map(({ objectID }) => objectID)
        .join(", ");

    DataLayer.track({
        event: "search",
        query,
        products: impressions,
        currency: application.currency.code,
        algoliaIndexType,
        algoliaDisplayedObjectIDs: objectIds,
    });
};
